import React from 'react';
import './master.css';


function BannerImage() {
    return(
        <div>
            <img className="banner" src="../images/pine_beams.jpg" alt="BannerImage" />
        </div>
    )
}

export default BannerImage;
